import { MultiSelect, Text } from "designSystem/index";
import { ComponentItem } from "designSystem/types/component-item-types";
import ArrayDataStore from "csi/datastore/ArrayDataStore";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";
import { items } from "designSystemLegacy/data";

const values = [items[0], items[1], items[2]];
const valuesSingle = [items[0]];
const valuesEmpty = [];

const data: ComponentItem[] = [];

for (let i = 0; i < 20; ++i) {
	data.push({
		id: i.toString(),
		name: `Item ${i}`,
	});
}

const store = new ArrayDataStore<ComponentItem>(data, "name");
const storeValues = [data[0], data[2]];

export default () => {
	return (
		<CssColumnGrid columns={2}>
			<Text semiBold text="Value = undefined (not specified)" />
			<MultiSelect
				noChips
				options={items}
				placeHolderRes="Select"
			/>
			<Text semiBold text="Value = [] (empty array)" />
			<MultiSelect
				noChips
				options={items}
				placeHolderRes="Select"
				value={valuesEmpty}
			/>
			<Text semiBold text="Value = [item] (single value)" />
			<MultiSelect
				noChips
				options={items}
				placeHolderRes="Select"
				value={valuesSingle}
			/>
			<Text semiBold text="Value = [item1, item2, item3] (multiple values)" />
			<MultiSelect
				noChips
				options={items}
				placeHolderRes="Select"
				value={values}
			/>
			<Text semiBold text="limitTags = 1" />
			<MultiSelect
				limitTags={1}
				noChips
				options={items}
				placeHolderRes="Select"
				value={values}
			/>
			<Text semiBold text="limitTags = 2" />
			<MultiSelect
				limitTags={2}
				noChips
				options={items}
				placeHolderRes="Select"
				value={values}
			/>
			<Text semiBold text="limitTags = 5" />
			<MultiSelect
				limitTags={5}
				noChips
				options={items}
				placeHolderRes="Select"
				value={values}
			/>
			<Text semiBold text="With Store" />
			<MultiSelect
				limitTags={1}
				noChips
				placeHolderRes="Select"
				store={store}
				value={[]}
			/>
			<Text semiBold text="With Store, 2 items selected" />
			<MultiSelect
				limitTags={1}
				noChips
				placeHolderRes="Select"
				store={store}
				value={storeValues}
			/>
		</CssColumnGrid>
	);
};